var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9761C13.6569 15.9761 15 14.6329 15 12.9761C15 11.3192 13.6569 9.97607 12 9.97607C10.3431 9.97607 9 11.3192 9 12.9761C9 14.6329 10.3431 15.9761 12 15.9761Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.856V12.096C2 11.056 2.85 10.196 3.9 10.196C5.71 10.196 6.45 8.91601 5.54 7.34601C5.02 6.44601 5.33 5.27601 6.24 4.75601L7.97 3.76601C8.76 3.29601 9.78 3.57601 10.25 4.36601L10.36 4.55601C11.26 6.12601 12.74 6.12601 13.65 4.55601L13.76 4.36601C14.23 3.57601 15.25 3.29601 16.04 3.76601L17.77 4.75601C18.68 5.27601 18.99 6.44601 18.47 7.34601C17.56 8.91601 18.3 10.196 20.11 10.196C21.15 10.196 22.01 11.046 22.01 12.096V13.856C22.01 14.896 21.16 15.756 20.11 15.756C18.3 15.756 17.56 17.036 18.47 18.606C18.99 19.516 18.68 20.676 17.77 21.196L16.04 22.186C15.25 22.656 14.23 22.376 13.76 21.586L13.65 21.396C12.75 19.826 11.27 19.826 10.36 21.396L10.25 21.586C9.78 22.376 8.76 22.656 7.97 22.186L6.24 21.196C5.33 20.676 5.02 19.506 5.54 18.606C6.45 17.036 5.71 15.756 3.9 15.756C2.85 15.756 2 14.896 2 13.856Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.2de8108ef75828a026793e9033c6c5b5.svg";
export { ForwardRef as ReactComponent };